[
  {
    "value": "Etc/GMT+12",
    "name": "(GMT-12:00) International Date Line West",
    "utc": ["Etc/GMT+12"]
  },
  {
    "value": "Pacific/Midway",
    "name": "(GMT-11:00) Midway Island, Samoa",
    "utc": ["Etc/GMT+11", "Pacific/Midway", "Pacific/Niue", "Pacific/Pago_Pago", "Pacific/Apia"]
  },
  {
    "value": "Pacific/Honolulu",
    "name": "(GMT-10:00) Hawaii",
    "utc": [
      "Etc/GMT+10",
      "Pacific/Honolulu",
      "Pacific/Johnston",
      "Pacific/Rarotonga",
      "Pacific/Tahiti"
    ]
  },
  {
    "value": "US/Alaska",
    "name": "(GMT-09:00) Alaska",
    "utc": [
      "America/Anchorage",
      "America/Juneau",
      "America/Nome",
      "America/Sitka",
      "America/Yakutat"
    ]
  },
  {
    "value": "America/Los_Angeles",
    "name": "(GMT-08:00) Pacific Time (US & Canada)",
    "utc": ["America/Los_Angeles", "America/Tijuana", "America/Vancouver"]
  },
  {
    "value": "America/Tijuana",
    "name": "(GMT-08:00) Tijuana, Baja California",
    "utc": ["America/Santa_Isabel"]
  },
  {
    "value": "US/Arizona",
    "name": "(GMT-07:00) Arizona",
    "utc": [
      "America/Creston",
      "America/Dawson",
      "America/Dawson_Creek",
      "America/Hermosillo",
      "America/Phoenix",
      "America/Whitehorse",
      "Etc/GMT+7"
    ]
  },
  {
    "value": "America/Chihuahua",
    "name": "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    "utc": ["America/Chihuahua", "America/Mazatlan"]
  },
  {
    "value": "US/Mountain",
    "name": "(GMT-07:00) Mountain Time (US & Canada)",
    "utc": [
      "America/Boise",
      "America/Cambridge_Bay",
      "America/Denver",
      "America/Edmonton",
      "America/Inuvik",
      "America/Ojinaga",
      "America/Yellowknife",
      "MST7MDT"
    ]
  },
  {
    "value": "America/Managua",
    "name": "(GMT-06:00) Central America",
    "utc": [
      "America/Belize",
      "America/Costa_Rica",
      "America/El_Salvador",
      "America/Guatemala",
      "America/Managua",
      "America/Tegucigalpa",
      "Etc/GMT+6",
      "Pacific/Galapagos"
    ]
  },
  {
    "value": "US/Central",
    "name": "(GMT-06:00) Central Time (US & Canada)",
    "utc": [
      "America/Chicago",
      "America/Indiana/Knox",
      "America/Indiana/Tell_City",
      "America/Matamoros",
      "America/Menominee",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Rainy_River",
      "America/Rankin_Inlet",
      "America/Resolute",
      "America/Winnipeg",
      "CST6CDT"
    ]
  },
  {
    "value": "America/Mexico_City",
    "name": "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
    "utc": [
      "America/Bahia_Banderas",
      "America/Cancun",
      "America/Merida",
      "America/Mexico_City",
      "America/Monterrey"
    ]
  },
  {
    "value": "Canada/Saskatchewan",
    "name": "(GMT-06:00) Saskatchewan",
    "utc": ["America/Regina", "America/Swift_Current"]
  },
  {
    "value": "America/Bogota",
    "name": "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    "utc": [
      "America/Bogota",
      "America/Cayman",
      "America/Coral_Harbour",
      "America/Eirunepe",
      "America/Guayaquil",
      "America/Jamaica",
      "America/Lima",
      "America/Panama",
      "America/Rio_Branco",
      "Etc/GMT+5"
    ]
  },
  {
    "value": "US/Eastern",
    "name": "(GMT-05:00) Eastern Time (US & Canada)",
    "utc": [
      "America/Detroit",
      "America/Havana",
      "America/Indiana/Petersburg",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Iqaluit",
      "America/Kentucky/Monticello",
      "America/Louisville",
      "America/Montreal",
      "America/Nassau",
      "America/New_York",
      "America/Nipigon",
      "America/Pangnirtung",
      "America/Port-au-Prince",
      "America/Thunder_Bay",
      "America/Toronto",
      "EST5EDT"
    ]
  },
  {
    "value": "US/East-Indiana",
    "name": "(GMT-05:00) Indiana (East)",
    "utc": ["America/Indiana/Marengo", "America/Indiana/Vevay", "America/Indianapolis"]
  },
  {
    "value": "Canada/Atlantic",
    "name": "(GMT-04:00) Atlantic Time (Canada)",
    "utc": [
      "America/Glace_Bay",
      "America/Goose_Bay",
      "America/Halifax",
      "America/Moncton",
      "America/Thule",
      "Atlantic/Bermuda"
    ]
  },
  {
    "value": "America/Caracas",
    "name": "(GMT-04:00) Caracas, La Paz",
    "utc": []
  },
  {
    "value": "America/Manaus",
    "name": "(GMT-04:00) Georgetown, La Paz, Manaus, San Juan",
    "utc": [
      "America/Anguilla",
      "America/Antigua",
      "America/Aruba",
      "America/Barbados",
      "America/Blanc-Sablon",
      "America/Boa_Vista",
      "America/Curacao",
      "America/Dominica",
      "America/Grand_Turk",
      "America/Grenada",
      "America/Guadeloupe",
      "America/Guyana",
      "America/Kralendijk",
      "America/La_Paz",
      "America/Lower_Princes",
      "America/Manaus",
      "America/Marigot",
      "America/Martinique",
      "America/Montserrat",
      "America/Port_of_Spain",
      "America/Porto_Velho",
      "America/Puerto_Rico",
      "America/Santo_Domingo",
      "America/St_Barthelemy",
      "America/St_Kitts",
      "America/St_Lucia",
      "America/St_Thomas",
      "America/St_Vincent",
      "America/Tortola",
      "Etc/GMT+4"
    ]
  },
  {
    "value": "America/Santiago",
    "name": "(GMT-04:00) Santiago",
    "utc": ["America/Santiago", "Antarctica/Palmer"]
  },
  {
    "value": "Canada/Newfoundland",
    "name": "(GMT-03:30) Newfoundland",
    "utc": ["America/St_Johns"]
  },
  {
    "value": "America/Sao_Paulo",
    "name": "(GMT-03:00) Brasilia",
    "utc": []
  },
  {
    "value": "America/Argentina/Buenos_Aires",
    "name": "(GMT-03:00) Buenos Aires, Georgetown",
    "utc": [
      "America/Argentina/La_Rioja",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia",
      "America/Buenos_Aires",
      "America/Catamarca",
      "America/Cordoba",
      "America/Jujuy",
      "America/Mendoza"
    ]
  },
  {
    "value": "America/Godthab",
    "name": "(GMT-03:00) Greenland",
    "utc": []
  },
  {
    "value": "America/Montevideo",
    "name": "(GMT-03:00) Montevideo",
    "utc": []
  },
  {
    "value": "America/Noronha",
    "name": "(GMT-02:00) Mid-Atlantic",
    "utc": ["America/Noronha", "Atlantic/South_Georgia", "Etc/GMT+2"]
  },
  {
    "value": "Atlantic/Cape_Verde",
    "name": "(GMT-01:00) Cape Verde Is.",
    "utc": ["Atlantic/Cape_Verde", "Etc/GMT+1"]
  },
  {
    "value": "Atlantic/Azores",
    "name": "(GMT-01:00) Azores",
    "utc": ["America/Scoresbysund", "Atlantic/Azores"]
  },
  {
    "value": "Africa/Casablanca",
    "name": "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
    "utc": [
      "Africa/Casablanca",
      "Africa/El_Aaiun",
      "Africa/Abidjan",
      "Africa/Accra",
      "Africa/Bamako",
      "Africa/Banjul",
      "Africa/Bissau",
      "Africa/Conakry",
      "Africa/Dakar",
      "Africa/Freetown",
      "Africa/Lome",
      "Africa/Monrovia",
      "Africa/Nouakchott",
      "Africa/Ouagadougou",
      "Africa/Sao_Tome",
      "Atlantic/Reykjavik",
      "Atlantic/St_Helena"
    ]
  },
  {
    "value": "Etc/Greenwich",
    "name": "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
    "utc": [
      "Atlantic/Canary",
      "Atlantic/Faeroe",
      "Atlantic/Madeira",
      "Europe/Dublin",
      "Europe/Lisbon"
    ]
  },
  {
    "value": "UTC",
    "name": "(GMT+00:00) Co-ordinated Universal Time",
    "utc": []
  },
  {
    "value": "Europe/Amsterdam",
    "name": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "utc": [
      "Arctic/Longyearbyen",
      "Europe/Amsterdam",
      "Europe/Andorra",
      "Europe/Berlin",
      "Europe/Busingen",
      "Europe/Gibraltar",
      "Europe/Luxembourg",
      "Europe/Malta",
      "Europe/Monaco",
      "Europe/Oslo",
      "Europe/Rome",
      "Europe/San_Marino",
      "Europe/Stockholm",
      "Europe/Vaduz",
      "Europe/Vatican",
      "Europe/Vienna",
      "Europe/Zurich"
    ]
  },
  {
    "value": "Europe/Belgrade",
    "name": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "utc": [
      "Europe/Belgrade",
      "Europe/Bratislava",
      "Europe/Budapest",
      "Europe/Ljubljana",
      "Europe/Podgorica",
      "Europe/Prague",
      "Europe/Tirane"
    ]
  },
  {
    "value": "Europe/Brussels",
    "name": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
    "utc": ["Africa/Ceuta", "Europe/Brussels", "Europe/Copenhagen", "Europe/Madrid", "Europe/Paris"]
  },
  {
    "value": "Europe/Sarajevo",
    "name": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "utc": ["Europe/Sarajevo", "Europe/Skopje", "Europe/Warsaw", "Europe/Zagreb"]
  },
  {
    "value": "Africa/Lagos",
    "name": "(GMT+01:00) West Central Africa",
    "utc": [
      "Africa/Algiers",
      "Africa/Bangui",
      "Africa/Brazzaville",
      "Africa/Douala",
      "Africa/Kinshasa",
      "Africa/Lagos",
      "Africa/Libreville",
      "Africa/Luanda",
      "Africa/Malabo",
      "Africa/Ndjamena",
      "Africa/Niamey",
      "Africa/Porto-Novo",
      "Africa/Tunis",
      "Etc/GMT-1"
    ]
  },
  {
    "value": "Asia/Amman",
    "name": "(GMT+02:00) Amman",
    "utc": []
  },
  {
    "value": "Europe/Athens",
    "name": "(GMT+02:00) Athens, Bucharest, Istanbul",
    "utc": ["Asia/Nicosia", "Europe/Athens", "Europe/Bucharest", "Europe/Chisinau"]
  },
  {
    "value": "Asia/Beirut",
    "name": "(GMT+02:00) Beirut",
    "utc": []
  },
  {
    "value": "Africa/Cairo",
    "name": "(GMT+02:00) Cairo",
    "utc": []
  },
  {
    "value": "Africa/Harare",
    "name": "(GMT+02:00) Harare, Pretoria",
    "utc": [
      "Africa/Blantyre",
      "Africa/Bujumbura",
      "Africa/Gaborone",
      "Africa/Harare",
      "Africa/Johannesburg",
      "Africa/Kigali",
      "Africa/Lubumbashi",
      "Africa/Lusaka",
      "Africa/Maputo",
      "Africa/Maseru",
      "Africa/Mbabane",
      "Etc/GMT-2"
    ]
  },
  {
    "value": "Europe/Helsinki",
    "name": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "utc": [
      "Europe/Helsinki",
      "Europe/Kiev",
      "Europe/Mariehamn",
      "Europe/Riga",
      "Europe/Sofia",
      "Europe/Tallinn",
      "Europe/Uzhgorod",
      "Europe/Vilnius",
      "Europe/Zaporozhye"
    ]
  },
  {
    "value": "Asia/Jerusalem",
    "name": "(GMT+02:00) Jerusalem",
    "utc": []
  },
  {
    "value": "Europe/Minsk",
    "name": "(GMT+02:00) Minsk",
    "utc": []
  },
  {
    "value": "Africa/Windhoek",
    "name": "(GMT+02:00) Windhoek",
    "utc": []
  },
  {
    "value": "Asia/Kuwait",
    "name": "(GMT+03:00) Kuwait, Riyadh, Baghdad",
    "utc": ["Asia/Aden", "Asia/Bahrain", "Asia/Kuwait", "Asia/Qatar", "Asia/Riyadh", "Asia/Baghdad"]
  },
  {
    "value": "Europe/Moscow",
    "name": "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
    "utc": [
      "Europe/Kirov",
      "Europe/Moscow",
      "Europe/Simferopol",
      "Europe/Volgograd",
      "Europe/Minsk"
    ]
  },
  {
    "value": "Africa/Nairobi",
    "name": "(GMT+03:00) Nairobi",
    "utc": [
      "Africa/Addis_Ababa",
      "Africa/Asmera",
      "Africa/Dar_es_Salaam",
      "Africa/Djibouti",
      "Africa/Juba",
      "Africa/Kampala",
      "Africa/Khartoum",
      "Africa/Mogadishu",
      "Africa/Nairobi",
      "Antarctica/Syowa",
      "Etc/GMT-3",
      "Indian/Antananarivo",
      "Indian/Comoro",
      "Indian/Mayotte"
    ]
  },
  {
    "value": "Asia/Tbilisi",
    "name": "(GMT+03:00) Tbilisi",
    "utc": []
  },
  {
    "value": "Asia/Tehran",
    "name": "(GMT+03:30) Tehran",
    "utc": []
  },
  {
    "value": "Asia/Muscat",
    "name": "(GMT+04:00) Abu Dhabi, Muscat",
    "utc": ["Asia/Dubai", "Asia/Muscat", "Etc/GMT-4"]
  },
  {
    "value": "Asia/Baku",
    "name": "(GMT+04:00) Baku",
    "utc": []
  },
  {
    "value": "Asia/Yerevan",
    "name": "(GMT+04:00) Yerevan",
    "utc": []
  },
  {
    "value": "Asia/Kabul",
    "name": "(GMT+04:30) Kabul",
    "utc": []
  },
  {
    "value": "Asia/Yekaterinburg",
    "name": "(GMT+05:00) Yekaterinburg",
    "utc": []
  },
  {
    "value": "Asia/Karachi",
    "name": "(GMT+05:00) Islamabad, Karachi, Tashkent",
    "utc": [
      "Antarctica/Mawson",
      "Asia/Aqtau",
      "Asia/Aqtobe",
      "Asia/Ashgabat",
      "Asia/Dushanbe",
      "Asia/Oral",
      "Asia/Samarkand",
      "Asia/Tashkent",
      "Etc/GMT-5",
      "Indian/Kerguelen",
      "Indian/Maldives"
    ]
  },
  {
    "value": "Asia/Calcutta",
    "name": "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi, Sri Jayawardenapura",
    "utc": ["Asia/Kolkata", "Asia/Colombo"]
  },
  {
    "value": "Asia/Katmandu",
    "name": "(GMT+05:45) Kathmandu",
    "utc": []
  },
  {
    "value": "Asia/Almaty",
    "name": "(GMT+06:00) Almaty, Novosibirsk",
    "utc": [
      "Antarctica/Vostok",
      "Asia/Almaty",
      "Asia/Bishkek",
      "Asia/Qyzylorda",
      "Asia/Urumqi",
      "Etc/GMT-6",
      "Indian/Chagos",
      "Asia/Novokuznetsk",
      "Asia/Novosibirsk",
      "Asia/Omsk"
    ]
  },
  {
    "value": "Asia/Dhaka",
    "name": "(GMT+06:00) Astana, Dhaka",
    "utc": ["Asia/Thimphu"]
  },
  {
    "value": "Asia/Rangoon",
    "name": "(GMT+06:30) Yangon (Rangoon)",
    "utc": ["Indian/Cocos"]
  },
  {
    "value": "Asia/Bangkok",
    "name": "(GMT+07:00) Bangkok, Hanoi, Jakarta",
    "utc": [
      "Antarctica/Davis",
      "Asia/Bangkok",
      "Asia/Hovd",
      "Asia/Jakarta",
      "Asia/Phnom_Penh",
      "Asia/Pontianak",
      "Asia/Saigon",
      "Asia/Vientiane",
      "Etc/GMT-7",
      "Indian/Christmas"
    ]
  },
  {
    "value": "Asia/Krasnoyarsk",
    "name": "(GMT+07:00) Krasnoyarsk",
    "utc": []
  },
  {
    "value": "Asia/Hong_Kong",
    "name": "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "utc": ["Asia/Macau", "Asia/Shanghai"]
  },
  {
    "value": "Asia/Kuala_Lumpur",
    "name": "(GMT+08:00) Kuala Lumpur, Singapore",
    "utc": [
      "Asia/Brunei",
      "Asia/Kuala_Lumpur",
      "Asia/Kuching",
      "Asia/Makassar",
      "Asia/Manila",
      "Asia/Singapore",
      "Etc/GMT-8"
    ]
  },
  {
    "value": "Asia/Irkutsk",
    "name": "(GMT+08:00) Irkutsk, Ulaan Bataar",
    "utc": []
  },
  {
    "value": "Australia/Perth",
    "name": "(GMT+08:00) Perth",
    "utc": ["Antarctica/Casey"]
  },
  {
    "value": "Asia/Taipei",
    "name": "(GMT+08:00) Taipei",
    "utc": []
  },
  {
    "value": "Asia/Tokyo",
    "name": "(GMT+09:00) Osaka, Sapporo, Tokyo",
    "utc": ["Asia/Dili", "Asia/Jayapura", "Etc/GMT-9", "Pacific/Palau"]
  },
  {
    "value": "Asia/Seoul",
    "name": "(GMT+09:00) Seoul",
    "utc": ["Asia/Pyongyang"]
  },
  {
    "value": "Asia/Yakutsk",
    "name": "(GMT+09:00) Yakutsk",
    "utc": ["Asia/Chita", "Asia/Khandyga"]
  },
  {
    "value": "Australia/Adelaide",
    "name": "(GMT+09:30) Adelaide",
    "utc": ["Australia/Adelaide", "Australia/Broken_Hill"]
  },
  {
    "value": "Australia/Darwin",
    "name": "(GMT+09:30) Darwin",
    "utc": []
  },
  {
    "value": "Australia/Brisbane",
    "name": "(GMT+10:00) Brisbane",
    "utc": ["Australia/Lindeman"]
  },
  {
    "value": "Australia/Canberra",
    "name": "(GMT+10:00) Canberra, Melbourne, Sydney",
    "utc": ["Australia/Melbourne", "Australia/Sydney"]
  },
  {
    "value": "Australia/Hobart",
    "name": "(GMT+10:00) Hobart",
    "utc": ["Australia/Currie", "Australia/Hobart"]
  },
  {
    "value": "Pacific/Guam",
    "name": "(GMT+10:00) Guam, Port Moresby",
    "utc": [
      "Antarctica/DumontDUrville",
      "Etc/GMT-10",
      "Pacific/Guam",
      "Pacific/Port_Moresby",
      "Pacific/Saipan",
      "Pacific/Truk"
    ]
  },
  {
    "value": "Asia/Vladivostok",
    "name": "(GMT+10:00) Vladivostok",
    "utc": ["Asia/Sakhalin", "Asia/Ust-Nera"]
  },
  {
    "value": "Asia/Magadan",
    "name": "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
    "utc": [
      "Asia/Anadyr",
      "Asia/Kamchatka",
      "Asia/Magadan",
      "Asia/Srednekolymsk",
      "Antarctica/Macquarie",
      "Etc/GMT-11",
      "Pacific/Efate",
      "Pacific/Guadalcanal",
      "Pacific/Kosrae",
      "Pacific/Noumea",
      "Pacific/Ponape"
    ]
  },
  {
    "value": "Pacific/Auckland",
    "name": "(GMT+12:00) Auckland, Wellington",
    "utc": ["Antarctica/McMurdo"]
  },
  {
    "value": "Pacific/Fiji",
    "name": "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
    "utc": ["Pacific/Fiji", "Asia/Kamchatka"]
  },
  {
    "value": "Pacific/Tongatapu",
    "name": "(GMT+13:00) Nuku'alofa",
    "utc": ["Etc/GMT-13", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Tongatapu"]
  }
]
